module.exports = __webpack_public_path__ + "img/nt116-04-81-1.prt.ad6bde43.jpg";